module.exports = __webpack_public_path__ + "static/i2-a0c5bfd725226363536754445dad2cdd.png";